<template>
    <div>
        <!-- Modal -->
        <div class="modal fade" id="agendarInfusaoModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-xl modal-dialog-scrollable" role="document">
                <div class="modal-content" v-if="receita">
                    <div class="modal-header">
                        <h5 class="modal-title">Agendar</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="alert alert-info d-flex justify-content-between" v-if="paciente">
                            <div>
                                {{ paciente.st_nome }}
                            </div>
                            <div>
                                <celula-dados-contatos :hor="{ marcacao: { paciente: paciente } }" />
                            </div>
                        </div>

                        <div v-if="novo_plano && paciente.paciente_unidade && paciente.paciente_unidade && paciente.paciente_unidade.id_plano != novo_plano" 
                            class="alert alert-warning d-flex justify-content-between">
                            <div>
                                Atual: {{ paciente.paciente_unidade.plano.search }}
                            </div>
                            <div>
                                <a href="#" @click.prevent="selecionar_novo_plano()">
                                    <i class="fa-solid fa-arrow-down"></i>
                                </a>
                            </div>
                        </div>

                        <div v-if="selecionado">

                            <div class="card mb-0">
                                <div class="card-header d-flex justify-content-between">
                                    <div>{{ selecionado.st_titulo }}</div>
                                    <div>#{{ selecionado.id_infusao }}</div>
                                </div>
                                <div class="card-body">
                                    <div>
                                        <i class="fa fa-calendar-o fa-fw mr-2" aria-hidden="true"></i>
                                        {{ $util.getFormatDate(selecionado.created_at) }}
                                    </div>
                                    <div v-if="selecionado.procedimento">
                                        <i class="fa fa-play fa-fw mr-2" aria-hidden="true"></i>
                                        {{ selecionado.procedimento.search }}
                                    </div>
                                    <div v-if="selecionado.plano">
                                        <i class="far fa-credit-card fa-fw mr-2"></i>
                                        <s v-if="selecionado.id_plano != selecionado.plano.id_plano">{{ selecionado.plano.search }}</s>
                                        <span v-else>{{ selecionado.plano.search }}</span>
                                    </div>
                                    <div v-if="selecionado.medico">
                                        <i class="fa fa-user-md fa-fw mr-2" aria-hidden="true"></i>
                                        {{ selecionado.medico.search }}
                                    </div>
                                    <div v-if="selecionado.protocolo && selecionado.protocolo.receita && selecionado.protocolo.receita.kit">
                                        <i class="fa-solid fa-prescription-bottle-medical fa-fw mr-2"></i>
                                        {{ selecionado.protocolo.receita.kit.st_nome }}
                                    </div>
                                    <div v-if="selecionado.marcacoes && selecionado.marcacoes.length">
                                        <div class="card mt-3 mb-0">
                                            <div class="card-header d-flex justify-content-between">
                                                <div>
                                                    <a href="#" @click.prevent="selecionado.fl_ativo = !selecionado.fl_ativo">
                                                        <i class="fa fa-plus-square-o fa-fw mr-2" aria-hidden="true" v-if="selecionado.fl_ativo"></i>
                                                        <i class="fa fa-minus-square-o fa-fw mr-2" aria-hidden="true" v-else></i>
                                                    </a>

                                                    <span v-if="selecionado.proxima_marcacao">
                                                        Próxima Marcação: {{ $util.getFormatDate(selecionado.proxima_marcacao.dt_inicio) }}
                                                        {{ selecionado.proxima_marcacao.dt_inicio.slice(11,16) }}
                                                    </span>
                                                    <span v-else>
                                                        Nenhuma marcação realizada
                                                    </span>
                                                </div>
                                                <div v-if="selecionado.marcacoes.length">
                                                    <span class="badge badge-secondary" title="Marcacões realizadas">
                                                        {{ selecionado.marcacoes.length }}
                                                    </span>
                                                </div>
                                            </div>
                                            <ul class="list-group" v-if="!selecionado.fl_ativo">
                                                <li class="list-group-item d-flex justify-content-between" v-for="(marcacao, imx) in selecionado.marcacoes" :key="imx">
                                                    <div>
                                                        {{ $util.getFormatDate(marcacao.dt_inicio) }}
                                                        {{ marcacao.dt_inicio.slice(11,16) }}
                                                        <span class="mx-2 text-muted" v-if="marcacao.st_regiao">
                                                            {{ marcacao.st_regiao }}
                                                        </span>
                                                        <i class="fa fa-check-circle" aria-hidden="true" v-if="marcacao.id_atendimento"></i>

                                                        <span v-if="marcacao.in_qt_ciclo" class="badge badge-secondary ml-2" title="Ciclo">
                                                            C{{ marcacao.in_qt_ciclo }}
                                                        </span>

                                                        <span v-if="marcacao.in_qt_dia" class="badge badge-secondary ml-2" title="D">
                                                            D{{ marcacao.in_qt_dia }}
                                                        </span>
                                                    </div>
                                                    <div v-if="marcacao.id_atendimento">
                                                        #{{ marcacao.id_atendimento }}
                                                    </div>
                                                    <div v-else-if="marcacao.autorizacao">
                                                        Autorização: 
                                                        <span class="badge ml-1" :class="'badge-' + marcacao.autorizacao.status_solicitacao.color">
                                                            {{ marcacao.autorizacao.status_solicitacao.msg }}
                                                        </span>
                                                    </div>
                                                </li>
                                            </ul>
                                            <div class="card-body" v-if="false">
                                                <pre>{{ selecionado }}</pre>
                                                <pre>{{ selecionado.marcacoes }}</pre>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="form-row mt-3" v-if="seleciona_plano">
                                        <div class="col col-12">
                                            <az-input 
                                                v-if="!trocando_plano"
                                                label="Operadora/Plano"
                                                sizing="sm"
                                                placeholder="Operadora/Plano"
                                                type="autocomplete" 
                                                optionsMode="aql"
                                                service="planos.index"
                                                :optionsSync="false"
                                                optionsData="id_plano"
                                                v-model="selecionado.id_plano"
                                                required
                                                :validate="validate"
                                                ref="info_plano" />
                                        </div>
                                    </div>

                                </div>
                                <div class="card-footer">
                                    <button type="button" class="btn btn-success" @click="agendar(selecionado)">Agendar</button>
                                </div>
                            </div>

                            <br><br><br><br><br>

                        </div>

                        <div v-else>
                            <div v-if="infusoes && !infusoes.length">
                                <div class="alert alert-secondary">Nenhuma planejamento de infusão registrado.</div>
                            </div>

                            <div v-else-if="infusoes && infusoes.length" class="mb-3">
                                <label>Protocolos Registrados</label>
                                <ul class="list-group">
                                    <li class="list-group-item d-flex justify-content-between" v-for="(infusao, ifx) in infusoes" :key="ifx" @click="selecionar_infusao(infusao)">
                                        <div>
                                            <div>{{ infusao.st_titulo }}</div>
                                            <div class="small">{{ $util.getFormatDate(infusao.created_at) }}</div>
                                        </div>
                                        <div class="text-right">
                                            <div v-if="infusao.procedimento">{{ infusao.procedimento.search }}</div>
                                            <div v-if="infusao.medico" class="small">{{ infusao.medico.search }}</div>
                                        </div>
                                    </li>
                                </ul>
                            </div>

                            <div class="card">
                                <div class="card-body">
                                    <div class="form-row">
                                        <div class="col col-12">
                                            <az-input 
                                                v-if="!trocando_plano"
                                                label="Operadora/Plano"
                                                sizing="sm"
                                                placeholder="Operadora/Plano"
                                                type="autocomplete" 
                                                optionsMode="aql"
                                                service="planos.index"
                                                :optionsSync="false"
                                                optionsData="id_plano"
                                                v-model="novo_plano"
                                                required
                                                :validate="validate"
                                                ref="info_plano" />
                                        </div>
                                    </div>
                                </div>
                                <div class="card-footer">
                                    <span v-if="1==0 && is_sessao(receita)" class="text-danger">
                                        <i class="fa fa-exclamation-triangle mr-2" aria-hidden="true"></i>
                                        Procedimento de Sessão
                                    </span>

                                    <az-submit color="success" @click="incluir_infusao(receita)" v-else>
                                        Incluir e Agendar
                                    </az-submit>
                                </div>
                            </div>

                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <button type="button" class="btn btn-primary" v-if="false">Save</button>
                    </div>
                </div>
            </div>
        </div>

        <!-- Modal Marcação -->
        <div class="modal fade" id="marcacaoModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-lg modal-dialog-scrollable" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">
                            {{ edicao_regiao ? 'Agendas' : 'Marcar' }}
                            <span class="badge badge-secondary ml-2" v-if="edicao">
                                #{{ edicao.id_infusao }}
                            </span>
                        </h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body" v-if="!edicao">
                        <az-empty-state />
                    </div>
                    <div class="modal-body" v-else>
                        <div class="alert alert-info">
                            <div class="lead d-flex justify-content-between">
                                <div>
                                    {{ edicao.paciente.st_nome }}
                                </div>
                                <div> 
                                    #{{ edicao.id_infusao }}
                                </div>
                            </div>
                            <div v-if="edicao.st_titulo">
                                {{ edicao.st_titulo }}
                            </div>
                            <div v-if="edicao.procedimento" class="text-muted">
                                {{ edicao.procedimento.search }}
                            </div>
                        </div>

                        <div class="alert alert-secondary small" v-if="edicao.dias && edicao.dias.length > 1">
                            Dias: {{ edicao.dias.join(', ') }}
                        </div>

                        <div class="row" v-if="edicao.ciclos && edicao.ciclos > 1">
                            <div class="col col-12">
                                <az-input
                                    type="number"
                                    label="Ciclo"
                                    v-model="edicao.in_qt_ciclo">
                                    <template v-slot:buttonposb>
                                        <div class="input-group-append" v-if="edicao.ciclos">
                                            <span class="input-group-text" id="basic-addon2">
                                                de {{ edicao.ciclos }}
                                            </span>
                                        </div>
                                    </template>
                                </az-input>
                            </div>
                        </div>

                        <template v-if="!edicao_regiao">

                            <template v-if="edicao.lista_dias && edicao.lista_dias.length">
                                <div class="row mt-3">
                                    <div class="col col-12 d-flex flex-column">
                                        <az-input
                                            type="button-group"
                                            :optionsList="[
                                                { id: 'S', search: 'Única' },
                                                { id: 'M', search: 'Dias' }
                                            ]"
                                            optionsData="id"
                                            v-model="edicao.tipo_marcacao" />
                                    </div>
                                </div>
                            </template>

                            <div class="row" v-if="edicao.tipo_marcacao != 'M'">
                                <div class="col col-12">
                                    <az-input
                                        v-if="edicao.js_dias"
                                        type="select"
                                        :optionsList="edicao.js_dias.map(item => { 
                                            return { 
                                                id: item,
                                                search: 'D' + item
                                            };
                                        })"
                                        optionsData="id"
                                        label="Dia"
                                        v-model="edicao.in_qt_dia" />

                                    <az-input
                                        v-else
                                        type="number"
                                        label="Dia"
                                        v-model="edicao.in_qt_dia" />
                                </div>
                            </div>

                            <div v-if="grupos && grupos.length">
                                <div class="row">
                                    <div class="col col-12">
                                        <az-input
                                            label="Prescrição"
                                            type="select"
                                            placeholder="Prescrição Completa..."
                                            :optionsList="grupos.map(item => { 
                                                return { 
                                                    id: item,
                                                    search: item
                                                };
                                            })"
                                            optionsData="id"
                                            v-model="edicao.st_agrupa" />
                                    </div>
                                </div>
                            </div>

                            <template v-if="edicao.lista_dias && edicao.lista_dias.length">
                                <table class="table table-sm table-hover mt-3">
                                    <thead>
                                        <tr>
                                            <th width="5%" v-if="edicao.tipo_marcacao == 'M'"></th>
                                            <th>D</th>
                                            <th>Agenda</th>
                                            <th>Atendimento</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(item, idx) in edicao.lista_dias" :key="idx"
                                            :class="( item.marcacao && item.marcacao.id_atendimento ) ? 'table-success' : ( item.marcacao ? 'table-primary' : '' )">
                                            <td v-if="edicao.tipo_marcacao == 'M'">
                                                <input type="checkbox" v-model="item.selecionado" :disabled="item.marcacao" />
                                            </td>
                                            <td>{{ item.search }}</td>
                                            <td>
                                                <template v-if="item.marcacao">
                                                    {{ $util.getFormatDate(item.marcacao.dt_inicio) }}
                                                    / {{ dia_da_semana($util.getFormatDate(item.marcacao.dt_inicio, 'd')) }}
                                                </template>

                                                <span class="text-muted small" v-else-if="item.prev_data">
                                                    {{ $util.getFormatDate(item.prev_data) }}
                                                    / {{ dia_da_semana($util.getFormatDate(item.prev_data, 'd')) }}
                                                </span>
                                            </td>
                                            <td>
                                                <template v-if="item.marcacao && item.marcacao.id_atendimento">
                                                    #{{ item.marcacao.id_atendimento }}
                                                </template>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </template>

                        </template>

                        <template v-else-if="!(edicao && edicao.marcacoes && edicao.marcacoes.length)">
                            Nenhuma Agenda Registrada.
                        </template>

                        <div class="mt-3" v-if="edicao && edicao.marcacoes && edicao.marcacoes.length">
                            <az-sub-title title="Agendas:" />
                            <ul class="list-group">
                                <li class="list-group-item d-flex py-2 justify-content-between" v-for="(marcacao, imx) in edicao.marcacoes" :key="imx">
                                    <div class="d-flex">
                                        {{ $util.getFormatDate(marcacao.dt_inicio) }}

                                        <div class="ml-2">
                                            <span class="badge badge-secondary" v-if="marcacao.in_qt_dia">
                                                D{{ marcacao.in_qt_dia }}
                                            </span>
                                        </div>

                                        <template v-if="!edicao_regiao || marcacao.id_atendimento || !grupos || !grupos.length">
                                            <span class="mx-2 text-muted" v-if="marcacao.st_regiao">
                                                {{ marcacao.st_regiao }}
                                            </span>
                                            <i class="fa fa-check-circle" aria-hidden="true" v-if="marcacao.id_atendimento"></i>
                                        </template>

                                        <template v-else-if="grupos && grupos.length">
                                            <az-input
                                                class="ml-3"
                                                sizing="sm"
                                                type="select"
                                                placeholder="Selecione..."
                                                :optionsList="grupos.map(item => { 
                                                    return { 
                                                        id: item,
                                                        search: item
                                                    };
                                                })"
                                                optionsData="id"
                                                required
                                                :validate="validate"
                                                v-model="marcacao.st_regiao" />
                                        </template>
                                    </div>
                                    <div v-if="marcacao.id_atendimento">
                                        #{{ marcacao.id_atendimento }}
                                    </div>
                                    <div v-else-if="marcacao.autorizacao && marcacao.autorizacao.status_solicitacao">
                                        Autorização: 
                                        <span class="badge ml-1" :class="'badge-' + marcacao.autorizacao.status_solicitacao.color">
                                            {{ marcacao.autorizacao.status_solicitacao.msg }}
                                        </span>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancelar</button>
                        <button type="button" class="btn btn-success" @click="marcar(edicao)" v-if="edicao && !edicao_regiao">Marcar</button>
                        <button type="button" class="btn btn-success" @click="atualizar_regiao(edicao)" v-if="edicao && edicao_regiao">Atualizar</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import $ from 'jquery';
import _ from 'lodash';
import * as moment from 'moment';
import AzSubmit from '../../util/AzSubmit.vue';
import AzInput from '../../shared/forms/AzInput.vue';
import CelulaDadosContatos from '../../shared/table/CelulaDadosContatos.vue';
import AzSubTitle from '../../util/AzSubTitle.vue';

export default { 
    data() {
        return { 
            receita: null, 
            infusoes: null, 
            selecionado: null, 
            edicao: null, 
            paciente: null,
            validate: false, 
            novo_plano: "", 
            seleciona_plano: false, 
            trocando_plano: false, 
        }
    },

    components: { 
        AzSubmit,
        AzInput,
        CelulaDadosContatos,
        AzSubTitle, 
    },

    props: ['edicao_regiao'], 

    computed: { 
        grupos: function () { 
            if ( !this.edicao )
                return [];

            let lista = _.get(this.edicao, 'protocolos.0.receita.items');

            if ( !lista ) { 
                return [];
            }

            return _.uniq(
                _.map(_.filter(lista, item => item && item.st_agrupa), 'st_agrupa')
            );
        }
    },
  
    methods: {
        selecionar_novo_plano () { 
            this.trocando_plano = true; 

            this.$nextTick(() => { 
                this.novo_plano = this.paciente.paciente_unidade.plano.id_plano;

                if ( this.selecionado ) { 
                    this.selecionado.id_plano = this.novo_plano;
                }

                this.trocando_plano = false; 
            });
        },

        is_sessao (receita) { 
            if (receita && receita.anamnese && receita.anamnese.atendimento_procedimento && receita.anamnese.atendimento_procedimento.procedimento ) { 
                return ( receita.anamnese.atendimento_procedimento.procedimento.id_classe_procedimento == 18 );
            }

            return false
        },
        dia_da_semana(dia) { 
            dia = parseInt(dia);

            switch (dia) {
                case 0: return 'Dom';
                case 1: return 'Seg';
                case 2: return 'Ter';
                case 3: return 'Qua';
                case 4: return 'Qui';
                case 5: return 'Sex';
                case 6: return 'Sáb';
                default: return dia;
            }
        },

        atualizar_regiao () { 

            this.$util.atualizar(this, { 
                service: "infusao",
                func: "atualizar_regiao", 
                dados: this.edicao,
                toast: true, 
                callback: () => { 
                    $('.modal').modal('hide');  
                    this.$emit('refresh');
                }
            });

        },

        incluir_infusao (receita) { 
            this.$util.atualizar(this, { 
                service: "infusao",
                func: "criar", 
                dados: { 
                    id_receita: receita.id_receita_base ? receita.id_receita_base : receita.id_receita,
                    id_plano: this.novo_plano, 
                },
                callback: res => { 
                    $('.modal').modal('hide');  
                    this.agendar(res);
                }
            });
        },

        agendar (infusao) { 

            this.validate= false;

            $('.modal').modal('hide');

            this.edicao = null;

            $('#marcacaoModal').modal('show');

            this.$util.load(this, { 
                service: 'infusoes',
                func: 'show',
                parms: { 
                    id: infusao.id_infusao,
                    id_plano: infusao.id_plano, 
                    edicao: true, 
                },
                loadTo: res => { 
                    res.in_qt_ciclo = 1;
                    res.in_qt_dia = 1;
                    res.st_agrupa = ""; 

                    if ( res.marcacoes ) { 
                        const ultima = _.last(res.marcacoes);

                        let lista_dias = res.js_dias ? res.js_dias : res.dias;

                        if ( ultima && ultima.in_qt_ciclo ) { 
                            res.in_qt_ciclo = ultima.in_qt_ciclo;

                            if ( ultima.in_qt_dia && ultima.in_qt_dia == res.duracao ) { 

                                res.in_qt_ciclo = res.in_qt_ciclo + 1;
                                res.in_qt_dia = 1;

                            } else if ( lista_dias && lista_dias.length ) { 

                                const idx = lista_dias.findIndex(item => item == ultima.in_qt_dia);

                                if ( idx >= 0 && idx < lista_dias.length ) { 
                                    res.in_qt_dia = lista_dias[idx + 1];
                                    res.in_qt_data = moment(ultima.dt_inicio)
                                        .add(res.in_qt_dia - ultima.in_qt_dia, "days")
                                        .format('YYYY-MM-DD');
                                }

                                res.tipo_marcacao = 'S';

                                res.lista_dias = lista_dias.map(item => { 
                                    let marcacao = res.marcacoes.find(marcacao => marcacao.in_qt_dia == item);

                                    return { 
                                        dia: item,
                                        search: 'D' + item, 
                                        marcacao: marcacao 
                                            ? { 
                                                id_marcacao: marcacao.id_marcacao,
                                                id_atendimento: marcacao.id_atendimento,
                                                dt_inicio: marcacao.dt_inicio,
                                                in_qt_dia: marcacao.in_qt_dia,
                                            }
                                            : null,
                                        prev_data: marcacao 
                                            ? ''
                                            : moment(ultima.dt_inicio)
                                                .add(item - ultima.in_qt_dia, "days")
                                                .format('YYYY-MM-DD'),
                                        selecionado: false, 
                                    };
                                });

                            } else if ( res.js_dias ) { 
                                const idx = res.js_dias.findIndex(item => item == ultima.in_qt_dia);

                                if ( idx >= 0 && idx < res.js_dias.length ) { 
                                    res.in_qt_dia = res.js_dias[idx + 1];
                                    res.in_qt_data = moment(ultima.dt_inicio)
                                        .add(res.in_qt_dia - ultima.in_qt_dia, "days")
                                        .format('YYYY-MM-DD');
                                }

                            } else { 

                                res.in_qt_dia = ultima.in_qt_dia + 1;

                            }
                        } else if ( lista_dias && lista_dias.length ) { 

                            res.tipo_marcacao = 'S';

                            res.lista_dias = lista_dias.map(item => { 
                                return { 
                                    dia: item,
                                    search: 'D' + item, 
                                    marcacao: null,
                                    prev_data: '',
                                    selecionado: false, 
                                };
                            });
                         
                        }
                    }

                    this.edicao = res;
                }
            });

            /*

            this.$nextTick(() => {
                this.$router.push({
                    name: "infusao",
                    params: { 
                        aba: 'marcacao', 
                        infusao: { 
                            id_infusao: infusao.id_infusao,
                            in_qt_ciclo: infusao.in_qt_ciclo,
                            in_qt_dia: infusao.in_qt_dia,
                            in_qt_data: infusao.in_qt_data, 
                            js_dias: infusao.js_dias,
                            id_procedimento: infusao.id_procedimento, 
                        }
                    }
                });
            });

            */

        },

        marcar (infusao) {
            
            if ( infusao && infusao.st_agrupa && infusao.marcacoes && infusao.marcacoes.length ) { 

                let teste = infusao.marcacoes.find(marc => marc.st_regiao && marc.st_regiao == infusao.st_agrupa);

                if ( teste ) { 
                    this.$toast.add({
                        severity: "error",
                        summary: "Atenção",
                        detail: infusao.st_agrupa + ' já agendado(a) para ' + this.$util.getFormatDate(teste.dt_inicio),
                        life: 3000
                    });
                    return;
                }

            }

            if ( infusao.ciclos ) { 
            
                if ( !infusao.in_qt_ciclo || infusao.in_qt_ciclo < 0 ) { 
                    this.$toast.add({
                        severity: "error",
                        summary: "Atenção",
                        detail: 'Ciclo não informado.',
                        life: 3000
                    });
                    return;
                } else if ( infusao.in_qt_ciclo > infusao.ciclos ) { 
                    /*
                    this.$toast.add({
                        severity: "error",
                        summary: "Atenção",
                        detail: 'Ciclo inválido: ' + infusao.in_qt_ciclo,
                        life: 3000
                    });
                    return;
                    */
                } 

            }

            if ( infusao && infusao.tipo_marcacao == 'M' ) { 
                
                let proximo = infusao.lista_dias.findIndex(item => item.selecionado); 
                if ( proximo < 0 ) { 
                    this.$toast.add({
                        severity: "error",
                        summary: "Atenção",
                        detail: 'Nenhum dia selecionado.',
                        life: 3000
                    });
                    return;
                } else { 
                    infusao.in_qt_dia = infusao.lista_dias[proximo].dia;
                    infusao.in_qt_data = infusao.lista_dias[proximo].prev_data;
                }

            } else if ( !infusao.in_qt_dia ) { 

                this.$toast.add({
                    severity: "error",
                    summary: "Atenção",
                    detail: 'Dia não informado.',
                    life: 3000
                });
                return;

            }

            $('.modal').modal('hide');

            this.$nextTick(() => {

                console.log('infusao', infusao);

                this.$router.push({
                    name: "infusao",
                    params: { 
                        aba: 'marcacao', 
                        infusao: { 
                            id_infusao: infusao.id_infusao,
                            id_plano: infusao.id_plano, 
                            in_qt_ciclo: infusao.in_qt_ciclo,
                            in_qt_dia: infusao.in_qt_dia,
                            in_qt_data: infusao.in_qt_data, 
                            js_dias: infusao.js_dias,
                            id_procedimento: infusao.id_procedimento, 
                            st_agrupa: infusao.st_agrupa,
                            lista: infusao.tipo_marcacao == 'M' 
                                ? infusao.lista_dias.filter(item => item.selecionado)
                                : [],  
                        }
                    }
                });
            });

        },

        abrir (receita) {
            console.log('receita', receita);

            this.infusoes = null, 
            this.selecionado = null, 
            this.seleciona_plano = false; 
            this.novo_plano = _.cloneDeep(_.get(receita, 'anamnese.atendimento_procedimento.atendimento.id_plano'));
            this.receita = _.cloneDeep(receita);
            this.paciente = _.get(receita, 'anamnese.atendimento_procedimento.atendimento.paciente');

            this.$util.load(this, { 
                service: "infusoes",
                func: "index", 
                parms: { 
                    paciente: this.paciente, 
                    valid_prescr: true, 
                },
                loadTo: res => { 

                    this.selecionado = res.find(item => item.protocolos.find(protocolo => protocolo.id_receita == receita.id_receita));

                    if ( !this.selecianado ) { 
                        let id_infusao = _.get(receita, 'anamnese.atendimento_procedimento.atendimento.marcacao.id_infusao');

                        if ( id_infusao ) { 
                            this.selecionado = res.find(item => item.id_infusao == id_infusao);
                        }
                    }

                    /*
                    if ( !_.get(receita, 'anamnese.atendimento_procedimento.atendimento.marcacao') ) { 
                        this.seleciona_plano = true;
                    }
                    */

                    this.seleciona_plano = true;

                    this.infusoes = res;

                }
            })

            $('#agendarInfusaoModal').modal('show');
        },
    }
}
</script>
